import { render } from "./TandartsBoxtel.vue?vue&type=template&id=c8af1660&scoped=true"
import script from "./TandartsBoxtel.vue?vue&type=script&lang=js"
export * from "./TandartsBoxtel.vue?vue&type=script&lang=js"

import "./TandartsBoxtel.vue?vue&type=style&index=0&id=c8af1660&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8af1660"]])

export default __exports__